import { render, staticRenderFns } from "./ContratoCargaDescarga.vue?vue&type=template&id=b39987d2"
import script from "./ContratoCargaDescarga.vue?vue&type=script&lang=js"
export * from "./ContratoCargaDescarga.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports